"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSessionCookieName = exports.SESSION_COOKIE_NAME_PREFIX = void 0;
// REPLACE: replace with cookie name prefix for project
exports.SESSION_COOKIE_NAME_PREFIX = "sps-next-session";
function getSessionCookieName(environment) {
    return "".concat(exports.SESSION_COOKIE_NAME_PREFIX, "-").concat(environment);
}
exports.getSessionCookieName = getSessionCookieName;
